<template>
    <div class="row">
        <div class="col mt-5 text-center">
            <img :src="logoImg" class="img-fluid rounded">
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                logoImg: require('./logo_org.png')
            }
        }
    }
</script>

<style scoped>
    img {
        max-height: 233px;
    }
</style>



// WEBPACK FOOTER //
// logo.vue?b8bd74e4